import { List, ListItem, ListItemButton, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";

import { PublicPclProduct } from "api/public/project/product/product.types";

const ConformanceClaimsCell = ({
  row: { product_id, protection_profiles },
}: {
  row: PublicPclProduct;
}) => {
  return (
    <List sx={{ width: "100%", textAlign: "center" }}>
      {protection_profiles
        .toSorted((a, b) => a.pp_short_name.localeCompare(b.pp_short_name))
        .map((pp) => {
          return (
            <Tooltip key={`${product_id}-${pp.pp_id}`} title={pp.pp_name}>
              <ListItem disablePadding>
                <ListItemButton
                  component={Link}
                  to={`/protectionprofiles/${pp.pp_id}`}
                  sx={{
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    textAlign: "center",
                    width: "100%",
                    textDecoration: "underline",
                    textUnderlineOffset: "3px",
                  }}
                >
                  {pp.pp_short_name || pp.pp_name}
                </ListItemButton>
              </ListItem>
            </Tooltip>
          );
        })}
    </List>
  );
};

export default ConformanceClaimsCell;
